import { captureMessage } from '@sentry/react';
import { enrichManifest } from '@/utilities/enrichManifest';
import { MANIFEST_STATUSES } from '@/constants/manifestStatuses';

const OUTBOUND_TYPES = ['WILL_CALL', 'RETURN_TO_SENDER', 'OUTBOUND'];

const mergeSummary = (enriched, summary, manifest) => {
    let status = summary.manifest_status || enriched.status;
    if (
        OUTBOUND_TYPES.includes(manifest?.type) &&
        ['inProgress', 'complete'].includes(manifest?.route?.status)
    ) {
        status = MANIFEST_STATUSES.COMPLETE;
    }
    return {
        ...enriched,
        status,
        received: summary.received_qty ?? enriched.received,
        staged: summary.staged_qty ?? enriched.staged,
        picked_up: summary.picked_up_qty ?? enriched.picked_up,
        total: summary.total_qty ?? enriched.total,
    };
};

// Detail-page query (INBOUND_ITEM_WAREHOUSE_FIELDS includes quantity + pallet.warehouse_status),
// so enrichManifest produces correct counts on its own — safe to fall back to.
export const normalizeManifestDetail = (manifest) => {
    const enriched = enrichManifest(manifest);
    const summary = manifest?.warehouse_summary;
    if (!summary) {
        return enriched;
    }
    return mergeSummary(enriched, summary, manifest);
};

// List-page query (INBOUND_ITEM_SUMMARY_FIELDS omits quantity + pallet for perf), so
// enrichManifest's received/staged/picked_up/total/status are unreliable. The view is the
// source of truth; surface null + Sentry when a row is missing rather than silently rendering
// broken zeros.
export const normalizeManifestListRow = (manifest) => {
    const enriched = enrichManifest(manifest);
    const summary = manifest?.warehouse_summary;
    if (!summary) {
        if (manifest?.manifest_id) {
            captureMessage('manifest_summary_view row missing for list manifest', {
                level: 'warning',
                extra: { manifest_id: manifest.manifest_id, type: manifest?.type },
            });
        }
        return {
            ...enriched,
            status: null,
            received: null,
            staged: null,
            picked_up: null,
            total: null,
        };
    }
    return mergeSummary(enriched, summary, manifest);
};
